module.exports = __webpack_public_path__ + "static/change-active-tabs-of-products-by-category-b643fb0359a41f2161c7b16dd770eaea.png";